<div class="customers-page">
  <div class="customers-header">
    <h2 class="customers-title">Customers</h2>
    <lib-cdw-button level="primary" type="button" (buttonClick)="onboardNew()">
      Onboard a customer
    </lib-cdw-button>
  </div>

  <lib-cdw-ssrm-grid
    class="customers-grid"
    viewKey="platform-customers"
    componentId="PlatformCustomersList"
    itemLabel="customer"
    filterBySelectedColumnName="id"
    [columnDefs]="columnDefs"
    [filterBarSettings]="filterBarSettings"
    [cdwSearchGridDataService]="customersDataService"
    (cellClicked)="onCellClicked($event)"
  ></lib-cdw-ssrm-grid>
</div>
